// In dev (vercel dev), VITE_AGENT_URL is empty → use relative paths (same origin).
// In prod, VITE_AGENT_URL points to the deployed agent server.
const agentUrl = import.meta.env.VITE_AGENT_URL || ''

export async function getAgentUrl(): Promise<string> {
  return agentUrl
}
